import styled from "styled-components";

const DotInfo = styled.div<{ color: string }>`
	min-width: 8px;
	height: 8px;
	background-color: ${(props) => props.color}; /* Correct property */
	border-radius: 50%;
`;

export { DotInfo };
